function initSpecSection(section) {
  if (!section || section.dataset.sidizSpecReady === 'true') return;

  const swiperElement = section.querySelector('.spec-swiper');
  const bullets = [...section.querySelectorAll('.spec-bullet')];

  if (swiperElement && typeof Swiper !== 'undefined') {
    const swiper = new Swiper(swiperElement, {
      slidesPerView: 1,
      autoHeight: true,
      on: {
        slideChange(instance) {
          const activeSlide = instance.slides[instance.activeIndex];
          const activeId = activeSlide?.dataset.id;
          bullets.forEach((bullet) => {
            const active = bullet.dataset.id === activeId;
            bullet.classList.toggle('active', active);
            bullet.setAttribute('aria-pressed', String(active));
          });
        },
      },
    });

    bullets.forEach((bullet) => {
      bullet.addEventListener('click', () => {
        const targetIndex = [...swiper.slides].findIndex(
          (slide) => slide.dataset.id === bullet.dataset.id,
        );
        if (targetIndex >= 0) swiper.slideTo(targetIndex);
      });
    });
  }

  const dialog = section.querySelector('[data-sidiz-spec-dialog]');
  const dialogImage = dialog?.querySelector('[data-sidiz-spec-dialog-image]');
  const dialogCaption = dialog?.querySelector('[data-sidiz-spec-dialog-caption]');
  const dialogClose = dialog?.querySelector('[data-sidiz-spec-close]');

  section.querySelectorAll('[data-sidiz-spec-zoom]').forEach((button) => {
    button.addEventListener('click', () => {
      const sourceImage = button.querySelector('img');
      if (!dialog || !dialogImage || !sourceImage) return;

      dialogImage.src = sourceImage.src;
      dialogImage.alt = sourceImage.alt;
      if (dialogCaption) dialogCaption.textContent = sourceImage.alt;

      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    });
  });

  dialogClose?.addEventListener('click', () => dialog.close());
  dialog?.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });

  section.dataset.sidizSpecReady = 'true';
}

function initSpecSections(root = document) {
  root.querySelectorAll('.section-product-spec').forEach(initSpecSection);
}

document.addEventListener('DOMContentLoaded', () => initSpecSections());

if (window.Shopify?.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.matches('.section-product-spec')) initSpecSection(event.target);
    else initSpecSections(event.target);
  });
}
